// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3n8Ii","messages":"Chat_messages__1J7Ro","dateDivider":"Chat_dateDivider__1tBl2"};